import { onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

export function setupUnsavedChangesGuard() {
  const store = useStore();

  const handler = (e: BeforeUnloadEvent) => {
    if (!store.getters["hasUnsavedChanges"]) {
      return;
    }

    e.preventDefault();

    e.returnValue = "";
  };

  onMounted(() => window.addEventListener("beforeunload", handler));

  onBeforeUnmount(() => window.removeEventListener("beforeunload", handler));
}
